(() => {
  function repairProductForm() {
    if (!document.body.classList.contains('template-product')) return;
    const details = document.querySelector('.product-details');
    const formContent = details?.querySelector('.group-block-content');
    const meta = details?.querySelector('.tw-product-meta');
    if (formContent && meta && meta.parentElement !== formContent) {
      formContent.prepend(meta);
      meta.dataset.twMetaPlaced = 'true';
    }

    document.querySelectorAll('.tfq-bundle').forEach((bundle) => {
      const buyTwo = bundle.querySelector('[data-tfq-tier][data-quantity="2"]');
      if (buyTwo) {
        buyTwo.dataset.percent = '10';
        const label = buyTwo.querySelector('.tfq-bundle__tier-off');
        if (label) label.textContent = '10% OFF';
      }
      const status = bundle.querySelector('[data-tfq-status]');
      if (status && /5%\s*OFF/i.test(status.innerHTML)) status.innerHTML = status.innerHTML.replace(/5%\s*OFF/gi, '10% OFF');
      if (status && !status.dataset.twPercentObserver) {
        status.dataset.twPercentObserver = 'true';
        new MutationObserver(() => {
          if (/5%\s*OFF/i.test(status.innerHTML)) status.innerHTML = status.innerHTML.replace(/5%\s*OFF/gi, '10% OFF');
        }).observe(status, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repairProductForm, { once: true });
  else repairProductForm();
  document.addEventListener('shopify:section:load', repairProductForm);
  document.addEventListener('cart:update', repairProductForm);
  document.addEventListener('cart:refresh', repairProductForm);
  window.setTimeout(repairProductForm, 700);
  window.setTimeout(repairProductForm, 1800);
})();
